module.exports = "<div class=\"e-drawer-overlay\" [class.open]=\"isOpen\" (click)=\"closeDrawer()\"></div>\n<div class=\"e-drawer-panel\" [class.open]=\"isOpen\">\n  <div class=\"e-drawer-header d-flex align-items-center justify-content-between\">\n    <span class=\"qr-title\">{{ title }}</span>\n    <button class=\"close-btn\" (click)=\"closeDrawer()\">&times;</button>\n  </div>\n  <div class=\"e-drawer-content\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/e-drawer/e-drawer.component.html
// module id = ../../../../../src/app/components/e-drawer/e-drawer.component.html
// module chunks = 3